import { HMLogoIcon } from './hm-logo-icon';
import { BackstageLogoIcon } from './backstage-logo-icon';
import { useTheme } from '@material-ui/core';

export const FullSideBarLogoIcon = () => {
  const theme = useTheme();
  const isDarkTheme = theme.palette.type === 'dark';
  const strokeColor = isDarkTheme
    ? theme.palette.divider
    : theme.palette.grey[400];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '10px',
        width: '100%',
        justifyContent: 'center',
        marginTop: 15,
      }}
    >
      <HMLogoIcon />
      <div style={{ padding: 0 }}>
        <svg height="30" width="2">
          <line
            x1="00"
            y1="29"
            x2="00"
            y2="00"
            style={{ stroke: strokeColor, strokeWidth: 2 }}
          />
        </svg>
      </div>
      <BackstageLogoIcon height={28} />
    </div>
  );
};
